import { render } from "./NameColorForm.vue?vue&type=template&id=dfd26e40&scoped=true&ts=true"
import script from "./NameColorForm.vue?vue&type=script&lang=ts"
export * from "./NameColorForm.vue?vue&type=script&lang=ts"

import "./NameColorForm.vue?vue&type=style&index=0&id=dfd26e40&scoped=true&lang=scss"

import exportComponent from "/Users/gerald/Projects/designium/RandselSimulation/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfd26e40"]])

export default __exports__